import { useMemo } from 'react';
import { seeded } from '../../lib/living';

/* An emoji that lives: plants sway in the (real) wind, creatures bob. */
export default function LivingEmoji({ children, className = '', seed, kind = 'sway' }) {
    const style = useMemo(() => {
        const r = seeded(String(seed ?? children));
        return { '--sway-delay': `${(-r() * 4).toFixed(2)}s`, '--sway-amp': `${(3 + r() * 4).toFixed(1)}deg` };
    }, [seed, children]);
    return (
        <span className={`living-emoji living-emoji--${kind} ${className}`} style={style} aria-hidden>
            {children}
        </span>
    );
}
